import { object, string } from 'yup'

const changePasswordScheme = object().shape({
  oldPassword: string()
    .required('passwordConfirmRequired')
    .min(6, 'passwordMinLength')
    .max(20, 'passwordMaxLength')
    .matches(
      /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*().\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{6,20})/,
      'passwordValidate'
    ),
  newPassword: string()
    .required('passwordRequired')
    .min(6, 'passwordMinLength')
    .max(20, 'passwordMaxLength')
    .matches(
      /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*().\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{6,20})/,
      'passwordValidate'
    ),
  confirmNewPassword: string()
    .required('passwordRequired')
    .test('passwords-match', 'passwordMustMatch', function (value) {
      return value === this.parent.newPassword
    }),
})

export default changePasswordScheme
